var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "menuBar" } }, [
    _c(
      "div",
      {
        staticClass: "item",
        on: {
          click: function ($event) {
            return _vm.change("Home")
          },
        },
      },
      [
        _vm.active === "Home"
          ? _c("img", {
              attrs: { src: require("@/assets/activeHome.png"), alt: "" },
            })
          : _c("img", {
              attrs: { src: require("@/assets/home.png"), alt: "" },
            }),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "item",
        on: {
          click: function ($event) {
            return _vm.change("RepayOrder")
          },
        },
      },
      [
        _vm.active === "RepayOrder"
          ? _c("img", {
              attrs: { src: require("@/assets/activeOrder.png"), alt: "" },
            })
          : _c("img", {
              attrs: { src: require("@/assets/order.png"), alt: "" },
            }),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "item",
        on: {
          click: function ($event) {
            return _vm.change("User")
          },
        },
      },
      [
        _vm.active === "User"
          ? _c("img", {
              attrs: { src: require("@/assets/activeUser.png"), alt: "" },
            })
          : _c("img", {
              attrs: { src: require("@/assets/user.png"), alt: "" },
            }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }